import { ArrowUpRight } from "lucide-react";

export default function CtaBanner() {
  return (
    <section data-testid="cta-banner" className="relative py-20 md:py-32 px-5 sm:px-6 md:px-10 border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF5A00]/10 via-transparent to-transparent pointer-events-none" />

      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-6 md:gap-8 items-center">
          <div className="col-span-12 md:col-span-8 min-w-0">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5A00] mb-4 md:mb-5">/ Start Your Digital Journey</div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-6xl font-semibold tracking-tight leading-[1.05] break-words">
              Ready to grow your<br />
              business <span className="text-[#FF5A00]">online?</span>
            </h2>
            <p className="text-zinc-400 mt-4 md:mt-6 max-w-xl text-sm sm:text-base">
              Let's build something amazing together. Free consultation, no obligations.
            </p>
          </div>
          <div className="col-span-12 md:col-span-4 flex flex-col gap-3 md:items-end">
            <a
              href="#contact"
              data-testid="cta-banner-primary"
              className="mv-btn-primary inline-flex items-center justify-center gap-2 px-7 py-4 text-sm font-medium rounded-sm w-full md:w-auto"
            >
              Contact Us
              <ArrowUpRight size={16} />
            </a>
            <a
              href="#contact"
              data-testid="cta-banner-secondary"
              className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-white/50 px-7 py-4 text-sm font-medium rounded-sm w-full md:w-auto transition-colors"
            >
              Get Free Quote
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
